const GreenLightHubRouter = () => {
  window.location.href =
    'https://bonjour.uber.com/marketplace/marketplaces/vehicle_ca/hourly_rental_options/product/de939db8-3fd8-5d76-99f5-02536e9e04c7/offer/67d4fd70-7fff-5c81-9cae-9197b5f774e1';
  return null;
};

export default GreenLightHubRouter;



// WEBPACK FOOTER //
// ./src/containers/GreenLightHubRouter.js